import { render } from "./OrdersAddView.vue?vue&type=template&id=5b02f3e4"
import script from "./OrdersAddView.vue?vue&type=script&lang=js"
export * from "./OrdersAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__